function assertNonEmptyList(list, cb) {
  if (list.length === 0) {
    cb == null ? void 0 : cb();
    throw Error("Unexpected empty list");
  }
}
function assertGetNonEmptyList(list, cb) {
  if (list.length === 0) {
    cb == null ? void 0 : cb();
    throw Error("Unexpected empty list");
  }
  return list;
}
function assertEmptyObject(value) {
  const keys = Object.keys(value);
  if (keys.length) {
    throw Error("Unexpected non-empty object, found " + keys.join(","), {
      cause: value
    });
  }
  return value;
}
function assertGetNonNullable(value, errorMessage) {
  if (value == null)
    throw Error(errorMessage);
  return value;
}

export { assertEmptyObject, assertGetNonEmptyList, assertGetNonNullable, assertNonEmptyList };
